import React, {lazy, useState} from 'react';
import CaseListingDetailsDetail from "./CaseListingDetailsDetail";
// import CaseListingDetailsBeforeAfterDetails from "./CaseListingDetailsBeforeAfterDetails";
import {useParams} from "react-router-dom";
const CaseListingDetailsBeforeAfterDetails = lazy(()=> import("./CaseListingDetailsBeforeAfterDetails"));

const CaseListingDetailsPage = () => {
    // retrieve id of the case from the params
    const { id } = useParams();

    return (
        <>
            <div className={"p-4"}>
                <div className="grid grid-cols-2">
                    {/*    Case Details */}
                    <CaseListingDetailsDetail id={id} />
                    {/*    Before - After */}
                    <CaseListingDetailsBeforeAfterDetails />
                </div>
            </div>
        </>
    );
};

export default CaseListingDetailsPage;